import { useSelector } from 'react-redux';
import { MaybeHelpDeskInboxIntercept } from 'svh-conversations-settings-lib/help-desk-onboarding/components/MaybeHelpDeskInboxIntercept';
import { hasHelpDeskAccess as hasHelpDeskAccessSelector } from '../../selectors/userSelectors/hasHelpDeskAccess';
import { getUsageTracker } from '../../usage-tracking/clients/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const TryHelpDeskBanner = () => {
  const hasHelpDeskAccess = useSelector(hasHelpDeskAccessSelector);
  const tracker = getUsageTracker().tracker;
  return hasHelpDeskAccess && tracker ? /*#__PURE__*/_jsx(MaybeHelpDeskInboxIntercept, {
    onTrack: tracker.track
  }) : null;
};
TryHelpDeskBanner.displayName = 'TryHelpDeskBanner';